import { Component, OnInit } from '@angular/core';
import { KnowHowService } from '../../services/know-how.service';
import { KnowHowDocumentsModel } from '../../models/documents/know-how-documents.model';
import { SharedToasterService } from '../../../shared/services/shared-toaster.service';
import { KnowHowDocumentsCategoryModel } from '../../models/documents/know-how-documents-category.model';
import { KnowHowDocumentsDocumentModel } from '../../models/documents/know-how-documents-document.model';
import { KnowHowDocumentsSportModel } from '../../models/documents/know-how-documents-sport.model';

@Component({
    selector: 'app-know-how-documents-overview',
    templateUrl: './know-how-documents-overview.component.html',
    styleUrl: './know-how-documents-overview.component.scss'
})
export class KnowHowDocumentsOverview implements OnInit {

    protected documents: KnowHowDocumentsModel | null = null;

    constructor(
        private knowHowService: KnowHowService,
        private sharedToasterService: SharedToasterService
    ) { }

    ngOnInit(): void {
        this.loadDocuments();
    }

    private loadDocuments(): void {
        this.knowHowService.getDocuments().subscribe({
            next: (documents) => {
                documents.sports = this.sortSports(documents.sports);
                documents.categories = this.sortCategories(documents.categories);

                this.documents = documents;
            },
            error: (error) => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    private sortSports(sports: KnowHowDocumentsSportModel[]): KnowHowDocumentsSportModel[] {
        sports = sports.sort((a, b) => a.name.localeCompare(b.name));

        sports.forEach(c => { c.categories = this.sortCategories(c.categories) });

        return sports;
    }

    private sortCategories(categories: KnowHowDocumentsCategoryModel[]): KnowHowDocumentsCategoryModel[] {
        categories = categories.sort((a, b) => a.name.localeCompare(b.name));

        categories.forEach(c => { c.documents = this.sortDocuments(c.documents) });

        return categories;
    }

    private sortDocuments(documents: KnowHowDocumentsDocumentModel[]): KnowHowDocumentsDocumentModel[] {
        documents = documents.sort((a, b) => a.sortOrder - b.sortOrder);
        return documents;
    }
}
